import {
  buildReserveSpotUrl,
  normalizeReserveErrorBody,
  getReserveSpotError,
  ReserveSpotErrorCode,
  type ReserveSpotError,
  type ReserveSpotWireErrorBody,
} from '@glofoxinc/room-layout-map/interactiveSpotBooking';

export { getReserveSpotError, ReserveSpotErrorCode };
export type { ReserveSpotError };

export async function reserveSpot(
  envUrl: string,
  userToken: string,
  bookingId: string,
  spotName: string
): Promise<void> {
  const response = await fetch(buildReserveSpotUrl(envUrl, bookingId, spotName), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + userToken,
    },
  });

  if (!response.ok) {
    let body: ReserveSpotWireErrorBody = {};
    try {
      body = await response.json();
    } catch (parseError) {
      body = {};
    }
    throw normalizeReserveErrorBody(body);
  }
}
